import { useNavigate } from 'react-router'
import { pathURL } from '@/components/constants/urls'
import { useUserLanguage } from '@/customHooks'
import chartIcon from '@/assets/sidebarIcons/chart-icon.svg'
import textsData from '@/textData/reportTexts.json'
import whiteRightArrow from '@/assets/white-right-arrow.svg'

export const ReportsPage = () => {
  const userLanguage = useUserLanguage()
  const languageTexts = userLanguage === 'es' ? textsData.es : textsData.en
  const texts = languageTexts.overview
  const navigate = useNavigate()

  const reports = [
    {
      id: 'alert-notices',
      icon: chartIcon,
      name: texts.reports.alertNotices,
      path: pathURL.ALERT_NOTICES,
    },
    {
      id: 'rent-charges',
      icon: chartIcon,
      name: texts.reports.rentCharges,
      path: pathURL.RENT_CHARGES,
    },
    {
      id: 'expenses',
      icon: chartIcon,
      name: texts.reports.expenses,
      path: pathURL.EXPENSES,
    },
    {
      id: 'contracts-roadmap',
      icon: chartIcon,
      name: texts.reports.contractsRoadmap,
      path: pathURL.CONTRACTS_ROADMAP,
    },
    {
      id: 'deposits',
      icon: chartIcon,
      name: texts.reports.deposits,
      path: pathURL.DEPOSITS,
    },
    {
      id: 'manager-ratings',
      icon: chartIcon,
      name: texts.reports.managerRatings,
      path: pathURL.MANAGER_RATINGS,
    },
  ]

  const handleReportClick = (path: string) => {
    navigate(`/${pathURL.USER}/${pathURL.REPORTS}/${path}`)
  }

  return (
    <div className="w-full px-4 md:px-6">
      
      {/* Title */}
      <h2 className="text-xl md:text-2xl font-semibold mb-6">
        {texts.title}
      </h2>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {reports.map((report) => (
          <div
            key={report.id}
            onClick={() => handleReportClick(report.path)}
            className="
              bg-white
              rounded-md
              p-6
              flex items-center justify-between
              cursor-pointer
              border border-transparent
              transition-all duration-200
              hover:border-primary1
              hover:shadow-md
              hover:-translate-y-0.5
            "
          >
            {/* Left Section */}
            <div className="flex items-center gap-4">
              <img
                src={report.icon}
                alt={report.name}
                className="w-6 h-6"
              />
              <span className="font-medium text-gray-800">
                {report.name}
              </span>
            </div>

            {/* Arrow */}
            <div
              className="
                w-7 h-7
                rounded-full
                bg-primary1
                flex items-center justify-center
                text-white
                text-sm
              "
            >
              <img src={whiteRightArrow} alt="Right arrow" className="w-4 h-4" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
/* 
import { Col, Container, Row } from 'react-grid-system';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { pathURL } from '@/components/constants/urls';
import { useUserLanguage } from '@/customHooks';
import chartIcon from '@/assets/sidebarIcons/chart-icon.svg';
import textsData from '@/textData/reportTexts.json';

const ReportCard = styled.div`
  background-color: ${({ theme }) => theme.colors.light};
  border-radius: ${({ theme }) => theme.border.radius.lg};
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary2};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;

const ReportIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  
  img {
    width: 24px;
    height: 24px;
  }
  
  span {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text};
  }
`;

const ArrowIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary1};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.8rem;
  
  &::after {
    content: '→';
  }
`;

export const ReportsPage = () => {
  const userLanguage = useUserLanguage();
  const languageTexts = userLanguage === 'es' ? textsData.es : textsData.en;
  const texts = languageTexts.overview;
  const navigate = useNavigate();
  const reports = [
    {
      id: 'rent-charges',
      icon: chartIcon,
      name: texts.reports.rentCharges,
      path: pathURL.RENT_CHARGES,
    },
    {
      id: 'expenses',
      icon: chartIcon,
      name: texts.reports.expenses,
      path: pathURL.EXPENSES,
    },
    {
      id: 'contracts-roadmap',
      icon: chartIcon,
      name: texts.reports.contractsRoadmap,
      path: pathURL.CONTRACTS_ROADMAP,
    },
  ];

  const handleReportClick = (path: string) => {
    navigate(`/${pathURL.USER}/${pathURL.REPORTS}/${path}`);
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <Row gutterWidth={2}>
        {reports.map((report) => (
          <Col md={6} sm={12} key={report.id}>
            <ReportCard onClick={() => handleReportClick(report.path)}>
              <ReportIcon>
                <img src={report.icon} alt={report.name} />
                <span>{report.name}</span>
              </ReportIcon>
              <ArrowIcon />
            </ReportCard>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
 */